export default "__VITE_ASSET__1e50634a__"